// ArrowButtons.tsx
import React from 'react';

interface ArrowProps {
    color?: string;
    // size?: number;
    // onClick?: () => void;
}

export const LeftArrow: React.FC<ArrowProps> = ({ color }) => (
    <span
        // onClick={onClick}
        className="tw-p-1 tw-rounded ">
        <svg
            width={20}
            height={20}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polyline points="15 18 9 12 15 6" />
        </svg>
    </span>
);

export const RightArrow: React.FC<ArrowProps> = ({ color }) => (
    <span
        // onClick={onClick}
        className="tw-p-1 tw-rounded ">
        <svg
            width={20}
            height={20}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polyline points="9 18 15 12 9 6" />
        </svg>
    </span>
);
